// extracted by mini-css-extract-plugin
export default {"errorPageWrapper":"error-page_errorPageWrapper__HpqZJ"};